import { rankWith, uiTypeIs } from '@jsonforms/core'
import { ENTITY_SELECTOR_RENDERER_META } from './EntitySelector'

export default rankWith(1, uiTypeIs(ENTITY_SELECTOR_RENDERER_META.type))
